import {ReactNode} from 'react';
import {Icon, Tooltip, view} from '@sail/ui';
import {info} from '@sail/icons/react/Icon';

export const Code = ({
  label,
  code,
  tooltip,
}: {
  label: ReactNode;
  code: string;
  tooltip: ReactNode;
}) => (
  <view.div
    css={{
      stack: 'x',
      distribute: 'space-between',
      marginX: 'space.150',
      alignY: 'center',
    }}
  >
    <view.span css={{font: 'label.small.emphasized'}}>
      {label}
      <Tooltip
        type="label"
        trigger={
          <Icon
            icon={info}
            size="small"
            css={{fill: 'subdued', marginLeft: 'space.75'}}
          />
        }
      >
        {tooltip}
      </Tooltip>
    </view.span>
    <view.span css={{font: 'body.large.emphasized'}}>{code}</view.span>
  </view.div>
);
